export default __webpack_public_path__ + "static/media/icon_target_date-past.d24106a4.svg";